import { ActionTypes } from '../actions';

const initialState = [];

const CommentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_COMMENTS:
      return action.payload;
    default:
      return state;
  }
};

export default CommentsReducer;
